export const MEDIA_HOST =
  process.env.REACT_APP_MEDIA_HOST || 'https://ik.imagekit.io/goboat/production';
export const STAPE_GTM_ID = 'GTM-KX28RJ3B';
